import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MmuFormatDatePipe } from './format-date/format-date.pipe';
import { MmuFormatNumberPipe } from './format-number/format-number.pipe';
import { MmuFormatTimePipe } from './format-time/format-time.pipe';
import { MmuHumanizeDurationPipe } from './humanize-duration/humanize-duration.pipe';
import { MmuUnitPipe } from './unit/unit.pipe';
import { MmuFormatTemperaturePipe } from './temperature/format-temperature.pipe';
import { MmuTemperaturePipe } from './temperature/temperature.pipe';
import { MmuMassPipe } from './mass/mass.pipe';
import { MmuFormatMassPipe } from './mass/format-mass.pipe';
import { MmuVolumePipe } from './volume/volume.pipe';
import { MmuFormatVolumePipe } from './volume/format-volume.pipe';
import { MmuLengthPipe } from './length/length.pipe';
import { MmuFormatLengthPipe } from './length/format-length.pipe';
import { MmuEnergyPipe } from './format-energy/energy.pipe';
import { MmuFormatEnergyPipe } from './format-energy/format-energy.pipe';

@NgModule({
  declarations: [
    MmuFormatDatePipe,
    MmuFormatNumberPipe,
    MmuFormatTimePipe,
    MmuHumanizeDurationPipe,
    MmuUnitPipe,
    MmuFormatTemperaturePipe,
    MmuTemperaturePipe,
    MmuMassPipe,
    MmuFormatMassPipe,
    MmuVolumePipe,
    MmuFormatVolumePipe,
    MmuLengthPipe,
    MmuFormatLengthPipe,
    MmuEnergyPipe,
    MmuFormatEnergyPipe
  ],
  imports: [CommonModule],
  exports: [
    MmuFormatDatePipe,
    MmuFormatNumberPipe,
    MmuFormatTimePipe,
    MmuHumanizeDurationPipe,
    MmuUnitPipe,
    MmuFormatTemperaturePipe,
    MmuTemperaturePipe,
    MmuMassPipe,
    MmuFormatMassPipe,
    MmuVolumePipe,
    MmuFormatVolumePipe,
    MmuLengthPipe,
    MmuFormatLengthPipe,
    MmuEnergyPipe,
    MmuFormatEnergyPipe
  ],
  providers: [DatePipe]
})
export class MmuFormattersModule {}
